var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 54,
    viewBox: "0 0 40 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25317,
    y: 22.8154,
    width: 38.1289,
    height: 29.2293,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1636 31.1132C19.1847 31.1201 18.2365 31.4346 17.4702 32.0064C16.7038 32.5781 16.1636 33.3743 15.9355 34.268C15.7075 35.1616 15.8047 36.1011 16.2119 36.9368C16.619 37.7725 17.3125 38.4561 18.1818 38.8786V43.7598H21.8181V39.0322C22.7569 38.6711 23.5331 38.0154 24.0143 37.1769C24.4954 36.3385 24.6517 35.3693 24.4564 34.4347C24.2612 33.5002 23.7265 32.6582 22.9436 32.0524C22.1607 31.4467 21.1782 31.1147 20.1636 31.1132Z",
    fill: "#EF6950"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5455 21.5727V14.268C34.6235 10.5677 33.137 6.989 30.411 4.31503C27.685 1.64105 23.9416 0.0895435 20 0C16.0584 0.0895435 12.315 1.64105 9.58902 4.31503C6.86305 6.989 5.37646 10.5677 5.45455 14.268V21.5727H0V50.5866C0 51.4919 0.383116 52.3601 1.06507 53.0002C1.74702 53.6404 2.67194 54 3.63636 54H36.3636C37.3281 54 38.253 53.6404 38.9349 53.0002C39.6169 52.3601 40 51.4919 40 50.5866V21.5727H34.5455ZM9.09091 14.268C9.01252 11.4728 10.1159 8.76218 12.16 6.72828C14.2041 4.69439 17.0227 3.50263 20 3.4134C22.9773 3.50263 25.7959 4.69439 27.84 6.72828C29.8841 8.76218 30.9875 11.4728 30.9091 14.268V21.5727H9.09091V14.268ZM3.63636 50.5866V24.9861H36.3636V50.5866H3.63636Z",
    fill: "#EF6950"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/Private.f46dcb96e9f74ad7da12e5a969b4b0ea.svg";
export { ForwardRef as ReactComponent };